{
  "+/na8S": "{experienceLevel}の募集中の職種",
  "+RBfjK": "<strong>政府当局</strong>― 法律、規制、または法的手続きによって要求される場合。",
  "+lsg50": "<strong>取引関連の連絡：</strong>応募状況の更新、面接のリマインダー、入社手続きの手順、その他応募または雇用に直接関連する連絡事項を、お客様の同意に基づき、SMS、メール、または電話で送信します。",
  "/GKTwV": "{startResult} - {endResult} / {totalCount}",
  "/SZPmm": "職種名またはキーワードで検索",
  "/pdLnE": "<strong>削除権：</strong>お客様は、特定の法的例外（記録保持義務など）を除き、当社に対しお客様の個人情報の削除を要求することができます。",
  "00m1vT": "<strong>自動的に収集されたデータ：</strong>プラットフォームプロバイダーの標準的なデータ保持ポリシーに従って保持されます。",
  "06JQuf": "5. 保証の免責",
  "0uj8CA": "求人情報と応募資格のある職種（マーケティング）",
  "0xKvFl": "<strong>アクセス権：</strong>お客様は、当社が保有するお客様の個人情報のコピーを請求することができます。",
  "1MNiI4": "{name}を選択してください",
  "1QOHHT": "勤務時間",
  "1WIMxg": "キャンセル",
  "1ma4gO": "弊社の採用サイトをご利用いただく際に、以下の種類の個人情報を収集する場合があります。",
  "2YzWOm": "申請開始",
  "2gDsJ9": "検索条件とフィルターを調整してください。",
  "2ysiB3": "すべてのフィルターをクリアする",
  "3CLJU9": "お問い合わせ先：<supportLink> {supportContact}</supportLink>",
  "3NW9w+": "{accountName} プライバシーポリシー",
  "3RG7Do": "6.あなたの権利と選択肢",
  "3Yr6Zd": "1. 本サイトの利用について",
  "3oHMyk": "お住まいの地域によっては、個人情報に関して以下の権利を有する場合があります。",
  "3qpbhl": "10. データセキュリティ",
  "3v8etI": "{position}の募集中の職種",
  "41OEjv": "当社は、お客様から直接（応募フォームを通じて）個人情報を収集するほか、プラットフォームプロバイダーの技術（当社の採用サイトに組み込まれたCookieおよび類似の技術を通じて）により自動的に個人情報を収集します。",
  "4ohioF": "<strong>プラットフォーム運用：</strong>当社は、プラットフォームプロバイダー（Fountain）に対し、不正行為の検出や技術的な問題の解決を含め、当社の採用サイトのセキュリティと機能を当社に代わって維持することを許可しています。",
  "56kYFg": "<strong>応募関連のSMS：</strong>ステータス更新、面接リマインダー、オンボーディング手順、および{accountName}への応募または雇用に直接関連するその他のメッセージ。<em>（取引関連）</em>",
  "5c0xwM": "オプトアウト後、確認メッセージが1通届きます。再登録するには、採用サイトから再登録するか、弊社からのメッセージに「START」と返信してください。",
  "6I7QkP": "ローカル",
  "6gJsj3": "プライバシーに関する方針",
  "7EUdCR": "当社の採用サイトを通じて応募書類を提出する際、お客様の個人情報は、当社に代わってプラットフォームプロバイダー（Fountain）によって直接収集されます。当社は、採用プロセスを支援する以下のカテゴリーのサービスプロバイダーとお客様の個人情報を共有する場合があります。",
  "7HOdgz": "（{location}）付近で募集中の職種は見つかりませんでした",
  "7K2KnA": "フィルター",
  "7O1CGZ": "このプライバシーポリシーについてご質問がある場合、またはお客様の権利を行使されたい場合は、当社までご連絡ください。",
  "7srJEb": "{brandName}で次のチャンスを見つけよう",
  "8R2FQ7": "申請開始",
  "8YcgIg": "/年",
  "8lJb89": "発効日：2026年4月",
  "8moA7E": "申込書のオプトインボックスにチェックを入れることにより、ご提供いただいた電話番号宛に{accountName}からSMSテキストメッセージを受信することに同意したものとみなされます。メッセージには以下が含まれる場合があります。",
  "9Jg0WQ": "並び替え順",
  "9TzuJX": "職種",
  "9ZVuvw": "<supportLink>{supportContact}</supportLink>",
  "9fotW7": "オプトアウトの方法：",
  "9gvBvK": "職種",
  "A939ot": "消去",
  "AEkpsv": "永久",
  "AXM0Ru": "プライバシーに関する方針",
  "Af+l/5": "{count, plural, other {求人{count,number}件}}",
  "AkOXuk": "<strong>デバイスおよび使用状況データ：</strong> IPアドレス、ブラウザの種類、デバイス識別子、オペレーティングシステム、およびIPアドレスから取得したおおよその位置情報",
  "Apa4NB": "11．子どものプライバシー",
  "BwwT2Q": "<strong>インタラクションデータ：</strong>採用サイトで閲覧したページ、滞在時間、応募プロセス内で実行した操作",
  "C/40b0": "ポジションを選択してください",
  "C5OA4b": "お客様の個人情報が上記に記載されたいずれの目的にも必要なくなった場合、当社はプラットフォームプロバイダーと連携し、適用されるデータ保持および廃棄手順に従って、お客様の個人情報を安全に削除または匿名化します。",
  "CIaoJm": "従業員ログイン",
  "CfEcpR": "<strong>差別を受けない権利：</strong>お客様がプライバシー権を行使したことを理由に、当社がお客様を差別することはありません。",
  "DTxAgM": "<strong>知る権利：</strong>お客様は、当社が収集したお客様に関する個人情報の種類と具体的な内容、その情報の出所、収集目的、および当社がその情報を共有した第三者の種類について、情報開示を請求することができます。",
  "DaFtVe": "<strong>身元調査サービス提供業者</strong>— 採用プロセスが進み、別途同意をいただいた場合、身元調査を実施するために、第三者のサービス提供業者と情報を共有することがあります。",
  "E+ZmsH": "当社の採用サイトは、プラットフォームプロバイダー（Fountain）を通じて運営されており、第2項で説明するデバイスおよび利用状況データを収集するために、Cookieおよび類似の技術を使用しています。これらの技術は、採用サイトの運営、利用状況の分析、およびパフォーマンスの向上を目的として、Fountainが当社に代わって導入しています。当社の採用サイトに設置されている特定のクッキーに関する詳細については、Fountainのプライバシーポリシーをご覧ください。<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "E2+MeX": "<strong>トラッキング拒否信号：</strong>当社の採用サイトは現在、「トラッキング拒否」（DNT）ブラウザ信号には対応していません。現時点では、DNT信号を認識または尊重するための統一された業界標準は存在しない。",
  "ECDDUw": "お客様がオプトアウトされた場合、当社は速やかにそのリクエストを処理いたします。マーケティングメッセージの受信を拒否しても、有効な応募や雇用関係に関連する取引メッセージには影響しません。ただし、それらのメッセージについては別途受信を拒否した場合は除きます。",
  "EJyETf": "応募手続きの過程で、以下の各種類のコミュニケーションについて、個別に同意を求められる場合があります。",
  "EZ7l60": "距離を選択してください",
  "F4rSq/": "<strong>メッセージ送信頻度：</strong>メッセージ送信頻度は、申請状況とアクティビティによって異なります。標準のメッセージ料金およびデータ料金が適用される場合があります。",
  "FD+Ak4": "フィルター",
  "FbMyuc": "<strong>SMS同意記録：</strong>テキストメッセージの受信を選択した場合、当社はお客様の同意選択の記録を収集および保持します。",
  "Fza3xO": "{count, plural, other {{query}（全地域）で利用可能な求人は{count,number}件です。}}",
  "G3uSr3": "並べ替え：",
  "GLUAB+": "{category}の募集中の職種",
  "GiGPOp": "<strong>応募書類の処理：</strong>資格の評価、面接のスケジュール調整、身元調査の実施（必要な場合は別途同意を得た上で）、および応募状況に関するご連絡",
  "GnfGtK": "本ポリシーを定期的にご確認いただくことをお勧めします。変更が掲載された後も引き続き弊社の採用サイトをご利用いただくことは、それ自体では改訂後の規約への同意とはみなされません。お客様の同意が必要な処理については、別途同意手続きが必要となります。",
  "GoyAbs": "「{query}」の検索結果",
  "Gx/VZ8": "フルタイム",
  "HjtQ1S": "<strong>当社はお客様の個人情報を販売しません。また、お客様の個人情報を、複数の状況における行動ターゲティング広告のために共有することもありません。</strong>",
  "IPBVH3": "9. クッキー、トラッキング技術、およびトラッキング拒否",
  "J4l/AQ": "管理職および専門職",
  "J8cmAm": "もっと見る（{count}）",
  "JC1ICT": "報酬タイプ",
  "Jlcabf": "<strong>機密性の高い個人情報：</strong>職種および適用される法律によっては、雇用確認または身元調査の目的で、政府発行の身分証明番号（社会保障番号や運転免許証番号など）を収集する場合があります。当社は、機密性の高い個人情報を、法律で認められた特定の目的のためにのみ処理し、プロファイリングや広告目的で使用することはありません。カリフォルニア州の住民は、当社による機密性の高い個人情報の利用を制限する権利を有します。詳細は第6項をご覧ください。",
  "JtmXU+": "検索 {name}",
  "KDjhll": "当社がEU/EEAまたは英国から米国へ個人情報を転送する場合、当社は以下の保護措置に依拠します。(a)該当する場合のEU-米国データプライバシーフレームワーク(DPF)、および/または(b)サービスプロバイダーとのデータ処理契約に組み込まれた、欧州委員会によって承認された標準契約条項(SCC)。該当する安全対策のコピーをご希望の場合は、下記までご連絡ください。<supportLink> {supportContact}</supportLink> 。",
  "KrXS5/": "配信停止をご希望の場合は、弊社からお送りするテキストメッセージに「STOP」と返信してください。",
  "L1t2kd": "メッセージの送信頻度は変動します。メッセージおよびデータ通信料がかかる場合があります。",
  "LOXUJb": "使用されるクッキーの種類：",
  "Lbwy5v": "職名",
  "LtyZus": "<strong>求人情報SMS：</strong> {accountName}で始まる、あなたが応募資格のあるその他の職種に関する情報。<em>（マーケティング目的の場合、別途オプトインが必要です）</em>",
  "MCzo6Q": "<strong>求人情報に関する電話：</strong> {accountName}社が提供している、あなたが応募資格を満たす可能性のある他の職種に関する電話。<em>（マーケティング目的の場合、別途オプトインが必要です）</em>",
  "Mf37lr": "上位のカテゴリー",
  "Mh1F+e": "{count, plural, other {{count,number}件のリモートワーク求人が見つかりました}}",
  "NG6g7y": "範囲",
  "Nkxa4f": "すべてのサービス提供者は、契約上、お客様の情報を保護し、当社が指定した目的にのみ使用し、サービスの提供に必要な期間を超えて情報を保持しないことが義務付けられています。",
  "OpSpNa": "当社は、お客様の個人情報を、収集目的を達成するために合理的に必要な期間保持します。これには、お客様が要求されたサービスの提供、お客様の応募の処理および評価、結果として生じる雇用関係のサポート、当社の法的および規制上の義務の遵守、紛争の解決などが含まれます。",
  "OuE0df": "<strong>販売／共有を拒否する権利：</strong>当社は、お客様の個人情報を、クロスコンテキスト行動ターゲティング広告のために販売または共有することはありません。当社はこれらの行為を行っていないため、オプトアウトは不要です。",
  "OxK884": "財務・会計",
  "PkU5jD": "<strong>すべてのチャネル：</strong>お問い合わせ<supportLink>{supportContact}</supportLink>すべてのコミュニケーションチャネルにおける同意設定を更新または取り消すことができます。",
  "Q43kt/": "<strong>応募関連の電話：</strong>応募状況、面接日程、入社手続きに関する電話連絡。<em>（取引関連）</em>",
  "QHXX/I": "<strong>通信サービスプロバイダー</strong>― 電話会社およびメッセージングサービスプロバイダー（テキストメッセージおよび電話の配信に必要な場合）。当社は、お客様のSMS受信登録状況や同意状況を含む個人データを、当社のメッセージングサービスの提供を支援する第三者（プラットフォームプロバイダー、電話会社、テキストメッセージの配信を支援するその他のベンダーなど）と共有する場合があります。この情報共有は、サービス提供の目的のみに使用されます。",
  "Qc+F6I": "それぞれの同意の選択は<strong>独立して</strong>います。これらのコミュニケーション方法のうち、いずれか、すべて、またはどれも選択しないことを選択できます。あなたの選択は、出願に影響しません。",
  "Qjh8MV": "<strong>サポートを受ける方法：</strong>サポートが必要な場合は、テキストメッセージに<strong>「HELP」</strong>と返信するか、以下の連絡先までお問い合わせください。<supportLink> {supportContact}</supportLink> 。",
  "QmFp6b": "<strong>Fountain, Inc.</strong> — 当社の採用プラットフォームプロバイダー。Fountainは、応募手続きを円滑に進め、SMSやその他の連絡事項を配信し、採用ワークフローを管理するために、当社に代わってお客様の個人情報を収集および処理します。Fountainのプライバシーポリシーは以下でご覧いただけます。<fountainPrivacyLink> fountain.com/privacy</fountainPrivacyLink> 。",
  "R+laqn": "カテゴリ",
  "R5pOCA": "以下の{brandName}から利用可能なすべての募集中の職種を確認するか、別の場所で募集中の職種を検索してください。",
  "RdNN/i": "任意",
  "RhRgl7": "<strong>訂正権：</strong>お客様は、不正確な個人情報の訂正を当社に要求することができます。",
  "RwsNjX": "2. SMSメッセージングプログラム",
  "ShbUPK": "市",
  "T0z9P/": "{count, plural, other {{radius} {unit} 以内で見つかった求人は {count,number} 件で、全 {location} 件のうちです。}}",
  "TBEZ9x": "募集中の職務名",
  "TuoZCm": "次の機会を見つける",
  "UKI/HU": "すべて",
  "Ud728E": "適用される法律で認められる最大限の範囲において、{accountName} は、お客様による本サイトまたは当社の SMS プログラムの使用から生じる間接的、偶発的、特別、または結果的な損害について一切責任を負いません。",
  "V/osST": "現在地",
  "VC3i9i": "本サイトおよびそのコンテンツは、明示的または黙示的な保証を一切伴わず、「現状のまま」提供されます。当サイトが中断なく、またはエラーなく動作することを保証するものではありません。",
  "VcjP63": "お客様の個人情報は、当社のプラットフォームプロバイダーであるFountainが主要なインフラストラクチャを運用している米国に転送され、そこで処理される場合があります。米国は、あなたの母国と同等のデータ保護レベルを提供していない可能性があります。",
  "VguvIP": "{count, plural, other {{query}で利用可能な求人は{count,number}件です。}}",
  "VoPWLM": "検索カテゴリ",
  "Vvd1rH": "当社は、これらの利用規約を定期的に更新する場合があります。変更が掲載された後も引き続き本サイトを利用する場合、改訂後の利用規約に同意したものとみなされます。",
  "WT6YVK": "前",
  "WjwoSF": "<strong>SMS同意記録：</strong>通信事業者およびFCCの記録保持要件に準拠し、規制遵守の目的で最低5年間保持されます。",
  "WuHcvG": "当社の採用サイトは、当社のサービスプロバイダーとしてお客様の個人情報を処理する人材管理プラットフォームである<strong>Fountain, Inc.</strong> （以下「Fountain」）によって運営されています。Fountainはデータ処理者として機能しますが、当社はデータ管理者として、お客様の個人情報がどのように、そしてなぜ処理されるかを決定する責任を負います。",
  "X1Y9Ps": "募集中の職種名で検索",
  "XPamEN": "/時間",
  "XcuBSu": "利用可能なすべての募集中の職種",
  "XjSvOF": "運営とリーダーシップ",
  "YDhGHb": "7. データ保持",
  "YQbDhN": "サービス利用規約",
  "YbL2yB": "<strong>雇用情報：</strong>職歴、学歴、スキル、資格、および応募書類の質問への回答",
  "Yoy6Jy": "以下の{brandName}から利用可能なすべての募集中の職種を確認するか、別の場所で募集中の職種を検索してください。",
  "Z4YDPm": "<strong>応募データ：</strong>採用された場合、応募データは雇用関係の期間中、および適用される雇用法、税法、記録保持法で義務付けられている合理的な期間、保持されます。採用に至らなかった場合でも、応募データは、将来の採用機会を検討するため、また法的および規制上の要件を遵守するために、通常は一定期間保管されます。ただし、法律でより短いまたはより長い保管期間が義務付けられている場合はこの限りではありません。",
  "a37+C1": "応募状況の更新、入社手続きに関する情報、その他雇用関連の通知（トランザクション情報）",
  "aD7/QV": "パートタイム",
  "aKWnwv": "ページ",
  "aaT0rw": "弊社の採用サイトにアクセスすると、プラットフォームプロバイダー（Fountain）が、弊社に代わってCookieや類似技術を使用して特定の情報を自動的に収集します。これには以下が含まれる可能性があります。",
  "avRBAo": "掲載日",
  "bQxKXO": "在宅ワーク",
  "c0TwrW": "求人名または場所で検索",
  "cP462m": "{count, plural, other {求人{count,number}件（全勤務地）}}",
  "cScov5": "<strong>SMS：</strong>受信したテキストメッセージに<strong>「STOP」</strong>と返信してください。「STOP」と返信すると、その番号からの<strong>すべてのSMSメッセージの</strong>受信が停止されます。特定のカテゴリのみをオプトアウトしたい場合（例：マーケティングSMSはオプトアウトするが、トランザクションSMSはオプトアウトしない）、以下の連絡先までお問い合わせください。<supportLink> {supportContact}</supportLink>設定を細かく更新できます。",
  "ccduZH": "<strong>EU/EEA/英国の申請者：</strong> eプライバシー指令（指令2002/58/EC）または英国のプライバシーおよび電子通信規則（PECR）で義務付けられている場合、必須ではないクッキーを設置する前に、お客様の同意を得ます。ブラウザの設定からクッキーの設定を管理できます。",
  "cnNa4F": "お客様の個人情報は当社のプラットフォームプロバイダー（Fountain）を通じて処理されるため、お客様のご要望にお応えするためにFountainと連携する場合があります。これは、お客様が当社に直接リクエストを送信する権利に影響を与えるものではなく、当社は適用される法律で定められた期間内にお客様に対応する責任を負います。",
  "coNrE4": "<strong>電話：</strong>発信者に削除希望の旨を伝えるか、当社までご連絡ください。<supportLink> {supportContact}</supportLink> 。",
  "ctMrd+": "<strong>携帯電話番号やSMSのオプトインまたは同意データを含むモバイル情報は、第三者または関連会社がマーケティングまたはプロモーション目的で使用するために共有されることはありません。</strong>その他のすべてのカテゴリには、テキストメッセージの発信者によるオプトインデータおよび同意は含まれません。この情報は第三者と共有されることはありません。",
  "dHKLYk": "チャットでお問い合わせ",
  "dINcE1": "検索ポジション",
  "dMBRRH": "社内採用サイト",
  "dSrjr/": "このプライバシーポリシーでは、 <strong>{accountName}</strong> （「当社」、「私たち」、または「当社の」）が、当社の採用サイトを通じて求人に応募する際に、お客様の個人情報をどのように収集、使用、保護するかについて説明します。",
  "eN7CVI": "8. 本規約の変更",
  "ePJ10M": "距離",
  "eWWpS5": "シャトル",
  "ejsFwD": "6. 責任の制限",
  "eoLsYT": "求人情報は見つかりませんでした。",
  "epJ7rX": "1. 私たちについて",
  "esYqDb": "13. お問い合わせ",
  "f5ZXVy": "本規約は、抵触法の規定にかかわらず、デラウェア州の法律に準拠し、同法に従って解釈されるものとします。本規約に基づいて生じる紛争は、デラウェア州に所在する州裁判所および連邦裁判所の専属管轄に服するものとします。",
  "f5xlBv": "{count, plural, other {{location} 付近で{count,number}件の求人が見つかりました}}",
  "f9XZvs": "サービス利用規約",
  "fHwoN4": "<strong>携帯電話番号、SMS受信状況、同意データなどのモバイル情報は、第三者または関連会社に対し、マーケティングやプロモーション目的で共有、販売、貸与されることはありません。</strong>モバイル端末のオプトインおよび同意情報は、お客様がリクエストされたメッセージを配信するために必要な場合に限り、通信サービスプロバイダー（通信事業者やメッセージングプラットフォームベンダーなど）と共有され、第三者の独自のマーケティング目的で使用されることはありません。",
  "fqbMOd": "ローケーション",
  "fz8Tvp": "<strong>必須クッキー：</strong>キャリアサイトの機能に必要です（例：セッション管理、セキュリティ）。これらは無効にできません。",
  "gKKaX9": "SMSメッセージの受信に同意することは、雇用への応募または採用の条件ではありません。",
  "ggOC46": "Fountainプラットフォームによるデータ処理方法について具体的なご質問がある場合は、Fountainのプライバシーチームまでお問い合わせください。<privacyMailLink> privacy@fountain.com</privacyMailLink>",
  "h8XXuO": "5. お客様情報の共有方法",
  "hCJFEI": "8. EU/EEA/英国の申請者向け：国際データ転送",
  "hNt7Xn": "検索",
  "hph9/b": "3. お客様情報の利用方法",
  "iVSyX5": "任意",
  "iwEvY/": "<strong>識別情報：</strong>氏名、メールアドレス、電話番号、住所",
  "jPYzxK": "2. 収集する情報",
  "jW9g8Q": "/月",
  "jjNqku": "場所を選択",
  "kDYV94": "リモートワーク、在宅勤務、在宅勤務、テレワーク",
  "kFJ1hG": "消去",
  "ki+WBr": "/日",
  "kkx0Di": "{count, plural, other {{query} のリモートワーク求人が{count,number}件見つかりました}}",
  "lDKw0M": "<strong>入社手続き：</strong>採用された場合、書類収集、研修スケジュールの調整、オリエンテーションなど、入社手続きを円滑に進める。",
  "lwRtGv": "場所を検索",
  "mOqk1N": "<strong>機密性の高い個人情報の利用を制限する権利：</strong>当社が機密性の高い個人情報（社会保障番号や政府発行の身分証明書など）を収集する場合、お客様は、当社がその情報を使用する目的を、お客様が合理的に期待するサービスを提供するために必要な目的に限定する権利を有します。この権利を行使するには、下記までご連絡ください。<supportLink> {supportContact}</supportLink> 。",
  "mqm7rH": "<strong>分析用クッキー：</strong>応募者が採用サイトをどのように利用しているかを把握するのに役立ちます。これらは、第三者の分析サービスによって提供される場合があります。",
  "mvv/A1": "近くの募集中の職種 {location}",
  "n/WRpL": "近くの募集中の職種は見つかりませんでした {location}",
  "n4YEE0": "消去",
  "nUNDHI": "当社は、お客様の個人情報が保護されるよう、合理的な措置を講じています。お客様のデータは当社のプラットフォームプロバイダー（Fountain）を通じて処理されるため、当社はFountainの技術的および組織的なセキュリティ管理に依存しています。これには、SOC 2 Type II認証、ISO 27001:2022認証、および転送中（TLS 1.2+）と保存時（AES-256）のデータ暗号化が含まれます。当社はFountain社とデータ処理契約を締結しており、Fountain社はお客様の個人情報を保護するために適切なセキュリティ対策を実施することが義務付けられています。",
  "nUYXYf": "契約社員／フリーランス",
  "nrL6lE": "詳細を見る（{count}）",
  "ntF3q4": "<strong>代理人：</strong>お客様は、ご自身に代わってプライバシーに関する要求を提出する代理人を指定することができます。代理人は、あなたの委任状（署名入りの書面による許可証や委任状など）の証明を提示する必要があり、当社はさらに、あなたに直接本人確認を求める場合があります。",
  "nxt8Qc": "カテゴリを選択",
  "o5G5gO": "場所で検索",
  "o5Lr3P": "<strong>法令遵守：</strong>記録保持、税務申告、雇用資格確認、政府機関からの合法的な要請への対応など、法的義務を履行する。",
  "oV4vX7": "募集職種",
  "oojjh4": "{accountName}（以下「当社」）が運営するサイトを利用することにより、お客様は本利用規約に同意するものとします。",
  "pCgcIl": "当社は、お客様の個人情報を以下の目的で使用します。",
  "pXg8OU": "<strong>マーケティングコミュニケーション：</strong>別途オプトインした場合、応募資格のある他の求人情報に関する情報をお送りします。",
  "pfzWdN": "カジュアル",
  "pjY7EJ": "<strong>必要書類：</strong>履歴書、政府発行の身分証明書（雇用確認に必要な場合）、および応募または入社手続き中にアップロードするその他の書類",
  "poL3TM": "メールアドレス:<supportLink> {supportContact}</supportLink>",
  "puJXDp": "3. 支援を受ける方法",
  "qt4wYG": "{accountName} プライバシーポリシー",
  "r1QaDh": "いかなる送信方法や保存方法も、完全に安全なものではない。当社はお客様の個人情報の保護に努めておりますが、絶対的な安全性を保証することはできません。",
  "r7Kb/z": "オプションはありません",
  "rUGq0i": "国／地域",
  "rdOcXL": "ログアウト",
  "rth6q8": "フィルター",
  "s0o3E7": "{brandName}での募集中の職種を検索",
  "sEzBNV": "<strong>テキストメッセージや電話の受信への同意は完全に任意であり、求人応募や雇用を得るための条件ではありません。</strong>ご希望されない場合は、メールでご連絡させていただく場合がございます。",
  "sR3x84": "研修生",
  "sox8LY": "当社は、本プライバシーポリシーを随時更新する場合があります。当社がお客様の個人情報の取り扱い方法に重大な変更を加える場合は、(a) 当社の採用サイトに目立つように通知を掲載し、(b) 可能な場合は、登録されている連絡先情報を通じて、応募中の応募者に通知します。改訂されたポリシーには、改訂後の発効日が明記されます。",
  "stlhl5": "<strong>カリフォルニア州にお住まいの方：</strong>カリフォルニア州消費者プライバシー法（CCPA/CPRAにより改正）に基づき、上記に記載されているすべての権利を有します。検証可能な消費者リクエストを送信するには、当社までご連絡ください。<supportLink> {supportContact}</supportLink> 。お客様のご依頼に対応する前に本人確認を行い、法律で定められている通り45日以内にご回答いたします。",
  "syNys9": "{count, plural, other {{query} に該当する求人が {count,number} 件見つかりました。{radius} {unit} 以内 {location}}}",
  "tIQhbD": "カスタマーサービス＆オペレーション",
  "tXdMLm": "当社の採用サイトは、16歳未満の方を対象としていません。当社は、16歳未満のお子様から意図的に個人情報を収集することはありません。お子様から情報を収集したと思われる場合は、下記までご連絡ください。<supportLink> {supportContact}</supportLink>そうすればすぐに削除できます。",
  "tYpw2s": "近くの募集中の職種（{location}）",
  "tbs+f9": "{accountName} プライバシーポリシーと利用規約",
  "tdTJ7T": "4. オプトアウトの方法",
  "toqXyd": "サービス利用規約",
  "tsGjFK": "マイル",
  "uMkyWa": "お客様から直接提供される情報：",
  "uq79O0": "場所名",
  "uy6hZs": "州/県",
  "w3RZCZ": "仕事",
  "w7EwgX": "12. 本プライバシーポリシーの変更",
  "wWh0//": "{count, plural, other {{location} 付近で {query} の求人が {count,number} 件見つかりました}}",
  "wdw5oL": "9. お問い合わせ",
  "wqAadg": "地域",
  "x+3jJQ": "キロメートル",
  "xUezuu": "データ保持期間は、当社のプラットフォームプロバイダー（Fountain）の機能および構成によって異なります。具体的なデータ保持期間についてご質問がある場合は、下記までお問い合わせください。<supportLink> {supportContact}</supportLink> 。",
  "xbL6qz": "7. 準拠法",
  "xgBjTg": "情報技術",
  "yIC7Pq": "/{lastPage}",
  "yJcC0I": "4. SMSおよび通話によるコミュニケーションプログラム",
  "yfcesY": "プラットフォームプロバイダーを通じて自動的に収集される情報：",
  "zBwVKO": "在宅ワーク",
  "zKRBxT": "このサイトは、求人応募や雇用関連の連絡を円滑にするために{accountName}によって運営されています。お客様は、本サイトを合法的な目的のみに使用し、かつ本利用規約に従うことに同意するものとします。",
  "zPvAKV": "一時的",
  "zabbLE": "次"
}
